/**
 * `/join` — entrar en una partida tecleando el código.
 *
 * Es exactamente la misma pieza que el panel de quien entra como alumnado, y a propósito: son la
 * misma acción, y tener dos versiones del campo más importante de la aplicación es tener dos
 * sitios donde se puede romper.
 *
 * La ruta sigue existiendo porque un enlace directo tiene que funcionar y porque el profesorado
 * también juega alguna vez desde su móvil.
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { SessionProfile } from '@clica/shared';
import { EntradaPin } from '../components/sistema/entrada-pin.js';
import { Marco } from '../components/sistema/marco.js';

export function PantallaEntrar({ profile }: { profile: SessionProfile }): React.JSX.Element {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('game.join.title')} · ${t('app.name')}`;
  }, [t]);

  return (
    // Con cabecera: se perdía entera, y con ella el idioma y la salida. Quien llegaba aquí por un
    // enlace directo no tenía forma de ir a ninguna otra parte.
    <Marco profile={profile} minima>
      <main
        id="contenido"
        className="mx-auto flex w-full max-w-md flex-col justify-center gap-8 p-6"
        style={{ minHeight: 'calc(100dvh - 5rem)' }}
      >
        <div className="entra text-center">
          <h1 className="font-display text-h2 font-extrabold text-balance">
            {t('game.join.title')}
          </h1>
          <p className="text-body text-text-dim mt-2">{t('game.join.lead')}</p>
        </div>

        <EntradaPin />
      </main>
    </Marco>
  );
}
